import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ShieldCheck, Mail, FileStack } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const STEPS = [
  { icon: FileStack, text: "Dipendenti, contratti, scadenze e cedolini in un unico gestionale" },
  { icon: ShieldCheck, text: "Contratti e UNILAV letti in automatico dalla casella email" },
  { icon: Mail, text: "Cedolini divisi e inviati a ogni dipendente con conferma" },
];

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <section className="relative hidden overflow-hidden bg-[#1f3a27] p-12 text-white lg:flex lg:flex-col lg:justify-between">
        <div className="ledger-grid absolute inset-0 opacity-30" />
        <p className="relative font-mono text-xs uppercase tracking-[0.25em] text-slate-400">Organico</p>
        <div className="relative space-y-10">
          <h1 className="font-display text-5xl font-extrabold leading-[1.05] tracking-tight">
            Il personale,<br />in ordine.<span className="text-[#7fb58a]">_</span>
          </h1>
          <ol className="space-y-5">
            {STEPS.map(({ icon: Icon, text }, i) => (
              <li key={text} className={`flex items-center gap-4 animate-rise delay-${i + 1}`}>
                <span className="font-mono text-xs text-slate-500">0{i + 1}</span>
                <Icon className="h-4 w-4 text-[#7fb58a]" />
                <span className="text-slate-300">{text}</span>
              </li>
            ))}
          </ol>
        </div>
        <p className="relative text-xs text-slate-500">Accessi separati per amministratori e operatori.</p>
      </section>

      <section className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 animate-rise" data-testid="login-form">
          <div className="space-y-2">
            <img src="/organico-logo.svg" alt="Organico" className="h-10 w-10 rounded-md" />
            <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">Accedi</h2>
            <p className="text-sm text-slate-600">Inserisci le tue credenziali per entrare nel gestionale.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" autoComplete="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" autoComplete="current-password" required value={password}
              onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {error && <p className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full active:scale-[0.98]" data-testid="login-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Accedi
          </Button>
          <p className="text-center text-sm text-slate-600">Non hai un account? <Link to="/registrazione" className="font-medium text-slate-900 underline" data-testid="go-to-register-link">Crea un nuovo account</Link></p>
          <p className="text-center text-sm"><Link to="/password-dimenticata" className="text-slate-500 underline" data-testid="forgot-password-link">Password dimenticata?</Link></p>
        </form>
      </section>
    </div>
  );
}
